import { useRef } from "react";
import { DeleteActiveObjectFunction, ObjectDeletingHandler } from "../extensions/objectDeletionExtension";
import { useSubscribeToDeleteActiveObjectEvent } from "./event/useDeleteActiveObjectEvent";

export function useObjectDeleteHandler() {
  const changeLayerFunctionRef = useRef<DeleteActiveObjectFunction>(() => {});

  useSubscribeToDeleteActiveObjectEvent(() => {
    changeLayerFunctionRef.current();
  });

  const initDeleteActiveObjectFunction = (fn: DeleteActiveObjectFunction) => {
    changeLayerFunctionRef.current = fn;
  };

  const handleObjectDeleting: ObjectDeletingHandler = (object) => {
    console.log("handleObjectDeleting", object);
  };

  return {
    initDeleteActiveObjectFunction,
    handleObjectDeleting,
  };
}
